import { render, staticRenderFns } from "./lesson-view.vue?vue&type=template&id=2bac2f2a&scoped=true&"
import script from "./lesson-view.vue?vue&type=script&lang=js&"
export * from "./lesson-view.vue?vue&type=script&lang=js&"
import style0 from "./lesson-view.vue?vue&type=style&index=0&id=2bac2f2a&scoped=true&lang=css&"
import style1 from "./lesson-view.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bac2f2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
